import { render } from "./LinkedInPrivacyPolicy.vue?vue&type=template&id=faefcbd0"
import script from "./LinkedInPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LinkedInPrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__